import script from "./EarthquakeController.vue?vue&type=script&setup=true&lang=ts"
export * from "./EarthquakeController.vue?vue&type=script&setup=true&lang=ts"

import "./EarthquakeController.vue?vue&type=style&index=0&id=70355e2f&lang=sass"

const __exports__ = script;

export default __exports__